'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import type { ExternalPackNftDto } from '~/lib/api';
import { WithdrawExternalNftFlow } from '~/module/nft/withdraw-external-nft-flow';
import { Button, SheetHeader } from '~/components/ui';

interface ExternalPackSheetContentProps {
  externalNft: ExternalPackNftDto;
  onSheetClose?: () => void;
}

export function ExternalPackSheetContent({ externalNft, onSheetClose }: ExternalPackSheetContentProps) {
  const t = useTranslations('my-collection.nft');
  const [showWithdrawFlow, setShowWithdrawFlow] = useState(false);

  const title = externalNft.externalCollection.collectionName;
  const imageUrl = externalNft.externalCollection.image ?? null;
  const isStaked = externalNft.stakedTill != null && new Date(externalNft.stakedTill).getTime() > Date.now();

  const handleWithdrawSuccess = () => {
    setShowWithdrawFlow(false);
    onSheetClose?.();
  };

  if (showWithdrawFlow) {
    return (
      <WithdrawExternalNftFlow
        externalNftId={externalNft.id}
        imageUrl={imageUrl}
        title={title}
        onSuccess={handleWithdrawSuccess}
      />
    );
  }

  return (
    <>
      <SheetHeader className="font-bold mt-[60px] text-center w-full mb-6 text-2xl items-center">
        <div>{title}</div>
      </SheetHeader>

      <div className="flex flex-col gap-6 px-4 flex-1 overflow-y-auto">
        {imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img alt={title} className="rounded-xl max-w-[200px] max-h-[200px] object-contain mx-auto" src={imageUrl} />
        ) : null}

        {!isStaked ? (
          <div className="pb-6">
            <Button
              className="w-full"
              variant="rainbow"
              onClick={() => {
                setShowWithdrawFlow(true);
              }}
            >
              {t('actions.withdraw')}
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
}
